var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageTextSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.94084 6.06901H8.27417M4.94084 8.40234H10.2742M4.94084 12.4023V13.9593C4.94084 14.3146 4.94084 14.4922 5.01366 14.5834C5.07699 14.6628 5.17302 14.7089 5.27453 14.7088C5.39125 14.7087 5.52995 14.5977 5.80734 14.3758L7.39765 13.1036C7.72251 12.8437 7.88495 12.7137 8.06583 12.6213C8.2263 12.5393 8.39712 12.4794 8.57365 12.4432C8.77262 12.4023 8.98063 12.4023 9.39667 12.4023H11.0742C12.1943 12.4023 12.7543 12.4023 13.1822 12.1844C13.5585 11.9926 13.8644 11.6866 14.0562 11.3103C14.2742 10.8825 14.2742 10.3224 14.2742 9.20234V5.60234C14.2742 4.48224 14.2742 3.92219 14.0562 3.49436C13.8644 3.11804 13.5585 2.81208 13.1822 2.62033C12.7543 2.40234 12.1943 2.40234 11.0742 2.40234H5.47417C4.35407 2.40234 3.79401 2.40234 3.36619 2.62033C2.98986 2.81208 2.6839 3.11804 2.49216 3.49436C2.27417 3.92219 2.27417 4.48224 2.27417 5.60234V9.73568C2.27417 10.3557 2.27417 10.6656 2.34232 10.92C2.52725 11.6102 3.06635 12.1493 3.75653 12.3342C4.01087 12.4023 4.32086 12.4023 4.94084 12.4023Z",
    stroke: "#475569",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageTextSquare);
export default __webpack_public_path__ + "static/media/message-text-square.deeea171a1021c43ece7765347b720d1.svg";
export { ForwardRef as ReactComponent };